import React, { useMemo } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import { useTranslations } from '../../contexts/LocalizationContext';
import { useScannedRelevosContext } from '../../contexts/ScannedRelevosContext';
import { useRestaurantsData } from '../../services/restaurants';
import RelevosUserSteps from './common/components/RelevosSteps/RelevosUserSteps';
import { SelectAssignmentMode } from './components/SelectAssignmentMode/SelectAssignmentMode';
import AssignSumUp from './components/SumUp/AssignSumUp';
import UserSelect from './components/UserSelect';
import { ItemAssignmentSelectMode, UserSelectMode } from './components/UserSelect/types';

export const Assign = () => {
  const translations = useTranslations();
  const { restaurantId, applicationUser, quickContact, selectItemMode } = useScannedRelevosContext();
  const { isQuickContactsEnabled } = useRestaurantsData();

  const secondStepDescription = useMemo(() => {
    switch (selectItemMode) {
      case ItemAssignmentSelectMode.CAMERA_SCAN:
        return translations('relevos_step_2_description');
      case ItemAssignmentSelectMode.HAND_SCANNER_SCAN:
        return translations('relevos_step_2_hand_scanner_description');
      case ItemAssignmentSelectMode.SELECT_CATEGORY:
        return translations('relevos_step_2_select_quantities_description');
      default:
        return undefined;
    }
  }, [selectItemMode, translations]);

  return (
    <>
      <Box p={2}>
        <Box width={'100%'} py={4}>
          <SelectAssignmentMode />
        </Box>
      </Box>
      <Flex bgColor={'beige.50'} width="100%" wrap="wrap" px={3} minH={'350px'}>
        <Box height="100%" py={4} width={['100%', '100%', '100%', '100%', '50%']}>
          <RelevosUserSteps
            firstStep={translations('relevos_step_1')}
            firstStepDescription={translations(
              isQuickContactsEnabled ? 'relevos_step_1_quick_contacts_description' : 'relevos_step_1_description',
            )}
            secondStep={translations('relevos_step_2')}
            secondStepDescription={secondStepDescription}
            isUpgrade={false}
            mode={UserSelectMode.ASSIGNMENT}
          />
        </Box>

        <Flex width={['100%', '100%', '100%', '100%', '50%']}>
          <Box width={['100%', '100%', '100%', '50%', '100%']}>
            <UserSelect mode={UserSelectMode.ASSIGNMENT} />
          </Box>
          {restaurantId && (applicationUser || quickContact) ? (
            <Box display={['none', 'none', 'block', 'block', 'none']} pt={6} pb={3}>
              <AssignSumUp />
            </Box>
          ) : null}
        </Flex>
      </Flex>
      <Box width={['100%', '100%', '100%', '55%']} display={['block', 'block', 'none', 'none', 'block']}>
        <AssignSumUp />
      </Box>
    </>
  );
};
